import React from "react";

export default function TransactionDetailsSkeleton({ rows = 7 }) {
  return (
    <div className="new-transaction-details__loading">
      {Array.from({ length: rows }).map((_, index) => (
        <span key={index} />
      ))}
    </div>
  );
}
